import React from 'react';

import { ArrowRight, CreditCard } from 'lucide-react';

import 'css/components/www/LandingV3/_LandingHero.scss';

import Link from 'common/Link';
import { demoLink, registerLink } from 'common/routeComponents/landing/core/constants';
import { P } from 'common/ui/Text';
import nbspLastSpace from 'common/util/nbspLastSpace';

type TextPretitleProps = {
  children: React.ReactNode;
};

const TextPretitle = ({ children }: TextPretitleProps) => {
  return <p className="LandingHero__pretitle">{children}</p>;
};

type Copy = {
  title: string;
  subtitle: string;
  demoButton?: string;
  registerButton?: string;
  cost?: string;
};

export type Props = {
  copy: Copy;
  registerLinkOverride?: string;
  demoLinkOverride?: string;
  pretitle?: React.ReactNode;
};

const LandingHero = ({
  copy: { title, subtitle, demoButton, registerButton, cost },
  registerLinkOverride = registerLink,
  demoLinkOverride = demoLink,
  pretitle = null,
}: Props) => {
  return (
    <section className="LandingHero">
      {pretitle}
      <h1 className="LandingHero__title">{title}</h1>
      <p className="LandingHero__subtitle">{nbspLastSpace(subtitle)}</p>
      {(registerButton || demoButton) && (
        <div className="LandingHero__ctas">
          {demoButton && (
            <Link
              to={demoLinkOverride}
              className="LandingHero__button LandingHero__button--outlined">
              {demoButton}
            </Link>
          )}
          {registerButton && (
            <Link to={registerLinkOverride} className="LandingHero__button LandingHero__button">
              {registerButton}
              <ArrowRight aria-hidden size={20} strokeWidth={1.5} />
            </Link>
          )}
        </div>
      )}
      {cost && (
        <P variant="bodyLg" className="LandingHero__cost">
          <CreditCard aria-hidden size={18} strokeWidth={1.5} />
          {cost}
        </P>
      )}
    </section>
  );
};

LandingHero.TextPretitle = TextPretitle;

export default LandingHero;
